import { render, staticRenderFns } from "./SetupChecklist.vue?vue&type=template&id=3c22388e&"
import script from "./SetupChecklist.vue?vue&type=script&lang=js&"
export * from "./SetupChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c22388e')) {
      api.createRecord('3c22388e', component.options)
    } else {
      api.reload('3c22388e', component.options)
    }
    module.hot.accept("./SetupChecklist.vue?vue&type=template&id=3c22388e&", function () {
      api.rerender('3c22388e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/SetupChecklist.vue"
export default component.exports